import { triggerTracking } from '@zoopla/tracking';
import { TRACKING_EVENT } from './constants/tracking';

export const trackGoogleOneTapClose = (currentStep: string) =>
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'registration',
        eventAction: 'form closed',
        eventLabel: `google_one_tap_step_${currentStep}`
    });
